import WrapperLayout from 'components/Layout';
import Main from "./Components/Main"
const TalentInsights = () =>{
    return(
        <>
        <WrapperLayout>
            <Main/>
        </WrapperLayout>
    </>
    )
}
export default TalentInsights